import { render, staticRenderFns } from "./CustomerNotesModal.vue?vue&type=template&id=2293bbc0&scoped=true&"
import script from "./CustomerNotesModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerNotesModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerNotesModal.vue?vue&type=style&index=0&id=2293bbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293bbc0",
  null
  
)

export default component.exports